import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { IconCalendarHeart02 } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";

import { ErrorModal, StatusBadge, SuccessModal } from "@components";

import { useLeaveBalanceReset } from "@hooks/HRM/leave/useLeaveBalanceReset";

import { ROUTES } from "@constants/routes";
import { STATUS } from "@constants/status.hrm";

import { resetLeaveBalance } from "@api/leave-balance";

const {
  HRM: { LEAVE },
} = ROUTES;
const { SUCCESS, FAILED } = STATUS;

export const LeaveSettingsHeader = () => {
  const [showResetBtn, setShowResetBtn] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  const { showButton, handleLeaveBalanceReset } = useLeaveBalanceReset();

  const handleResetBalance = () => {
    resetLeaveBalance((response) => {
      if (response.status === SUCCESS) {
        setIsSuccessModalOpen(true);
        handleLeaveBalanceReset(false);
      } else if (response.status === FAILED) setIsErrorModalOpen(true);
    });
  };

  // error and success modal
  const closeErrorModal = () => setIsErrorModalOpen(false);
  const successAction = () => setIsSuccessModalOpen(false);

  useEffect(() => {
    const reset = () => {
      setIsErrorModalOpen(false);
      setIsSuccessModalOpen(false);
    };
    return reset();
  }, []);

  useEffect(() => {
    setShowResetBtn(showButton);
  }, [showButton]);

  const breadcrumbs = [
    {
      icon: <IconCalendarHeart02 fill="dark" size="20" />,
    },
    {
      label: t("LEAVE_SETTINGS.BREADCRUMBS.FIRST_STEP"),
      link: LEAVE,
    },
    {
      label: t("LEAVE_SETTINGS.BREADCRUMBS.SECOND_STEP"),
    },
  ];

  const headerText = {
    header: t("LEAVE_SETTINGS.HEADING"),
  };

  const actionButtons = [
    showResetBtn ? (
      <Button
        key="reset_btn"
        htmlType="button"
        fill="fill"
        type="info"
        onClick={handleResetBalance}
      >
        {t("LEAVE_SETTINGS.RESET_BUTTON")}
      </Button>
    ) : (
      <StatusBadge
        key="reset_txt"
        customStatus="success"
        status="This year, all leave balances have been reset."
      />
    ),
  ];

  return (
    <>
      {/* MODAL SECTION */}
      <>
        <SuccessModal isModalOpen={isSuccessModalOpen} action={successAction} />
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      </>
      {/* MODAL SECTION */}
      <Header
        headerText={headerText}
        breadcrumbs={breadcrumbs}
        actions={actionButtons}
      />
    </>
  );
};
